// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__H_EdB","info":"PatientInfo_info__VdIG0"};